module.exports = __webpack_public_path__ + "img/Imagen 10.03b78111.jpg";